import { GtmEventType } from '@gn-audio/jss-core';

export enum HearingTestEventAction {
  LoadPage = 'Load Page',
  Click = 'Click',
  SelectGender = 'Select Gender',
  SelectAge = 'Select Age',
  SelectHearingLevel = 'Select Hearing Level',
  SelectHearingEnvironment = 'Select Hearing Environment',
  SelectDesign = 'Select Design',
  SelectComfort = 'Select Comfort',
  SelectWearing = 'Select Wearing',
  LeftEarScore = 'Left Ear Average Score',
  RightEarScore = 'Right Ear Average Score',
  ClickResultLink = 'Click Result Link',
}

export interface HearingTestTrackingPayload {
  event: GtmEventType;
  eventCategory: string;
  eventAction: HearingTestEventAction | string;
  eventLabel: string | number;
}
